import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper px-3 mx-auto" }
const _hoisted_2 = {
  class: "box has-text-centered px-1-mobile",
  ref: "modalContent"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_top_up_leads = _resolveComponent("top-up-leads")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_top_up_leads, {
        plansToShow: _ctx.planstoShow,
        onScrollToTop: _ctx.handleScrollToTop
      }, null, 8, ["plansToShow", "onScrollToTop"])
    ], 512)
  ]))
}